// Bulleted intro shown under a page's MainTitle, explaining what the page is for.
const PageDescription = ({ contents }) => (
    <div className='ml-4 mb-4'>
        <ul className='list-disc list-outside text-left text-sm text-gray-500'>
            {contents.map((e, i) => <li key={i}>{e}</li>)}
        </ul>
    </div>
)

export default PageDescription
